module.exports = __webpack_public_path__ + "static/media/travelingbymoto3.284095d7.png";